import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import { signUp } from '../api/auth';
import './SignUp.css';

const SignUp = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    userType: 'coach', // Default user type
  });
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Add your logic for form submission here
    const response = await signUp(formData)
    if (response.status === 200) {
      navigate('/')
    }
  };

  return (
    <div className="signUpContainer">
      <h2>Sign Up</h2>
      <form onSubmit={handleSubmit}>
        <label>
          First Name:
          <input
            type="text"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            required
          />
        </label>
        <br />
        <label>
          Last Name:
          <input
            type="text"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            required
          />
        </label>
        <br />
        <label>
          Email:
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </label>
        <br />
        <label>
          Type:
          <select
            name="userType"
            value={formData.userType}
            onChange={handleChange}
            required
          >
            <option value="coach">Coach</option>
            <option value="director">Director</option>
            <option value="admin">Admin</option>
            <option value="adminViewOnly">Admin (View Only)</option>
          </select>
        </label>
        <br />
        <button type="submit">Sign Up</button>
      </form>
      <Link to="/login" relative="path">
        Already have an account?
      </Link>
    </div>
  );
};

export default SignUp;